module.exports = __webpack_public_path__ + "static/git-59863c6180caa67a7d0c00e13727a828.png";